import { BtnClose } from './Button';
import LinkSafe from './LinkSafe';
import Modal from './Modal';
import { Tit } from './Titles';
import Image from '@/components/Image';
import Youtube from '@/components/Youtube';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC } from 'react';
import styled from 'styled-components';

export interface ModalProps {
  isOpen?: boolean;
  // 모달 바깥쪽 누를시 닫을수 있는지 여부
  dismissable?: boolean;
  // 닫힘요청시 콜백
  onRequestClose: () => void;
  maxWidth?: string;
}

interface EndviolenceLayerProps extends ModalProps {
  PopupSid: string | number;
  PopupHeader: string;
  PopupImg: string;
  PopupTitle: string;
  PopupDec: string;
  PopupYoutube?: string;
  PopupLocale?: string;
  PopupThumYoutube?: string;
}

const PopCcontainer = styled.div`
  padding: 0 32px;

  ${breakpoint(`tablet`)} {
    padding: 0 20px;
  }
`;

const PopTitle = styled.div`
  border-bottom: 1px solid #1cabe2;
  position: relative;
  padding: 22px 0;

  ${BtnClose} {
    position: absolute;
    cursor: pointer;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);

    &::before,
    &::after {
      background: #1cabe2;
    }
  }
`;

const PopContent = styled.div`
  padding-top: 32px;
  padding-bottom: 83px;
  .card-img {
    width: 100%;
  }

  ${Tit} {
    margin-top: 32px;
  }
  .dec {
    margin-top: 16px;
    line-height: 1.7;
  }

  ${LinkSafe} {
    margin-top: 32px;
  }
`;

const EndviolenceLayerPopup: FC<EndviolenceLayerProps> = ({
  onRequestClose,
  ...props
}) => (
  <Modal onRequestClose={onRequestClose} maxWidth="640px" {...props}>
    <PopCcontainer>
      <PopTitle>
        <h2>
          <Tit size="s3" color="sky">
            {props.PopupHeader}
          </Tit>
        </h2>
        <BtnClose onClick={() => onRequestClose()}>
          <span className="a11y">닫기</span>
        </BtnClose>
      </PopTitle>
      <PopContent>
        {props.PopupThumYoutube ? (
          <Youtube
            noneTab
            className="youtube-container"
            endViolence={props.PopupThumYoutube}
          />
        ) : (
          <Image
            className="card-img"
            pcSrc={props.PopupImg}
            mobileSrc={props.PopupImg}
          />
        )}

        <Tit size="s4-1">{props.PopupTitle}</Tit>
        <p className="dec">{props.PopupDec}</p>
        {props.PopupYoutube && (
          <LinkSafe to={props.PopupYoutube} className="link-blank">
            {props.PopupLocale === `ko`
              ? `*영상 확인하기: ${props.PopupYoutube}`
              : `watch the video: ${props.PopupYoutube}`}
          </LinkSafe>
        )}
      </PopContent>
    </PopCcontainer>
  </Modal>
);

export default EndviolenceLayerPopup;
